module.exports = __webpack_public_path__ + "static/media/nasa_curiosity.763b8450.usdz";